import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { createSafeContext } from '@coveord/plasma-mantine';
var _createSafeContext = _sliced_to_array(createSafeContext('EmptyState component was not found in tree'), 2);
export var EmptyStateProvider = _createSafeContext[0], useEmptyStateContext = _createSafeContext[1];

//# sourceMappingURL=EmptyStateContext.js.map